// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es7.math.scale.js
// module id = 1356
// module chunks = 168707334958949